import { Box, Button, CircularProgress, IconButton, TextField, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { ChangeEvent, FC, useState } from "react";
import { GenericFunction } from "../types/generic.types";

import CustomCard from "./CustomCard";

const CancelingReason: FC<RejectionReasonProps> = ({
  counter = 32,
  handleCloseModal,
  onRejectRecord,
  message = "Cancellation Reason",
}) => {
  const [rejectionReason, setRejectionReason] = useState("");
  const [loading, setLoading] = useState(false);

  const onMessageChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setRejectionReason(value);
  };

  const handleSubmit = async () => {
    if (rejectionReason) {
      setLoading(true);
      await onRejectRecord(rejectionReason.trim());
      setLoading(false);
    }
  };

  return (
    <CustomCard withMarginBottom={false} width="75vw" height="300px">
      <Box display="flex" height="100%" alignItems="center">
        <Box width="100%">
          <Box mb={2} display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h5" color="textSecondary">
              {message}
            </Typography>

            <IconButton onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
          </Box>

          <TextField
            multiline
            rows={5}
            variant="outlined"
            value={rejectionReason}
            onChange={onMessageChange}
            fullWidth
            label="Message"
            inputProps={{
              maxLength: counter,
            }}
            helperText={
              <Typography variant="overline" style={{ padding: 4 }}>
                {`${counter - rejectionReason.length}`}/{counter}
              </Typography>
            }
          />

          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button
              variant="contained"
              color="primary"
              disabled={
                !(rejectionReason && rejectionReason.trim().length > 0) || loading || rejectionReason.length > counter
              }
              onClick={handleSubmit}
              startIcon={loading ? <CircularProgress size={16} style={{ color: "grey" }} /> : null}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Box>
    </CustomCard>
  );
};

interface RejectionReasonProps {
  onRejectRecord: GenericFunction;
  handleCloseModal: GenericFunction;
  counter?: number;
  message?: string;
}

export default CancelingReason;
